import { Typography, Checkbox } from "antd";
import moment from "moment";
import { RiCloseCircleFill, RiCheckboxCircleFill } from "react-icons/ri";
const dateFormat = "YYYY-MM-DD";

const { Text } = Typography;

const formatData = (date) => moment(date).format("Do MMM' YY");

const getGreyBoxData = (data = {}) => {
  const finalData = [];
  if (data.email) {
    finalData.push({
      message: "Email id is required to view catalogue",
      render: () => <RiCheckboxCircleFill color="#B4B7B6" size={20} />,
    });
  } else {
    finalData.push({
      message: "Email id is NOT required to view catalogue",
      render: () => <RiCloseCircleFill color="#B4B7B6" size={20} />,
    });
  }
  if (data.expiry) {
    const endDate = moment(data.expiry.to);
    const todayDate = moment(moment().format("YYYY-MM-DD"));
    if (endDate.isSameOrAfter(todayDate)) {
      finalData.push({
        message: `Link will be active till ${formatData(data.expiry.to)}`,
        render: () => <RiCheckboxCircleFill color="#B4B7B6" size={20} />,
      });
    }
  }

  if (data.passcode) {
    finalData.push({
      message: `Passcode is set to ${data.passcode}`,
      render: () => <RiCheckboxCircleFill color="#B4B7B6" size={20} />,
    });
  }
  return finalData;
};

const setInitialdata = (data = {}, reactivateLinkSettings) => {
  const finalData = {};

  if (data.email) {
    finalData.email = true;
  } else if (data.email === false) {
    finalData.email = false;
  }

  if (data.expiry && !reactivateLinkSettings) {
    const endDate = moment(data.expiry.to);
    const todayDate = moment(moment().format("YYYY-MM-DD"));
    if (endDate.isSameOrAfter(todayDate)) {
      finalData.setExpiry = true;
      finalData.expiry = {
        from: moment(data.expiry.from),
        to: moment(data.expiry.to),
      };
    }
  }
  if (data.passcode) {
    finalData.passcode = data.passcode;
    finalData.setPasscode = true;
  }
  return finalData;
};

export const CheckboxContainer = ({
  label1,
  label2,
  id,
  value,
  onChange,
  children,
  errorState,
}) => {
  return (
    <div style={{ marginBottom: "1rem" }}>
      <Checkbox
        style={{
          marginLeft: 0,
          display: "flex",
          alignItems: "flex-start",
        }}
        id={id}
        onChange={onChange}
        checked={value}
      >
        <div
          style={{
            marginLeft: "0.5rem",
            flexDirection: "column",
            display: "flex",
          }}
        >
          <Text strong style={{ color: "#040E0C" }}>
            {label1}
          </Text>
          <Text style={{ marginTop: "0.1rem", color: "#4F5655" }}>
            {label2}
          </Text>
        </div>
      </Checkbox>
      <div style={{ marginLeft: 24 }}>
        <div style={{ marginLeft: "1rem" }}>
          {children && <div style={{ marginTop: "1rem" }}>{children}</div>}
          {errorState?.id === id && (
            <span style={{ marginTop: "0.3rem", color: "red" }}>
              {errorState.message}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

const isLinkSecure = (data = {}) => {
  if (data.email === false && Object.keys(data).length === 1) return false;
  return true;
};

const getExpiryText = (data = {}) => {
  if (!data?.security_data?.expiry) return "No expiry on link";
  const expiry = data.security_data.expiry;
  const todayDate = moment().format("YYYY-MM-DD");
  const startDate = moment(expiry.from);
  const endDate = moment(expiry.to);

  if (startDate.isAfter(todayDate)) return "";

  const diff = endDate.diff(todayDate, "days");
  if (diff < 0) return "Link is expired";
  if (diff === 0) return "Link expires today";
  if (diff === 1) return "Link expires in 1 day";
  if (diff <= 5) return `Link expires in ${diff} days`;

  return "";
};

export default {
  getGreyBoxData,
  setInitialdata,
  isLinkSecure,
  getExpiryText,
};
